var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuestTalk2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131.475,
    height: 130.623,
    viewBox: "0 0 131.475 130.623",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83",
    transform: "translate(397.524 -4420.435)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_81",
    "data-name": "Group 81",
    transform: "translate(-341.815 4431.142)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_417",
    "data-name": "Path 417",
    d: "M3140.146,2318.018a3.887,3.887,0,0,1-1.281-.633,4.254,4.254,0,0,0-1.286-.525c-.645-.135-1.294.029-1.941-.059a.667.667,0,0,1-.577-.333,10.792,10.792,0,0,1,5.387,1.579A2.112,2.112,0,0,1,3140.146,2318.018Z",
    transform: "translate(-3088.181 -2206.067)",
    fill: "#f2faff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_448",
    "data-name": "Path 448",
    d: "M2569.592,991.98l-2.264,8.453-12.767,1.985-.1,2.692s11.326,1.808,14.51-.172c2.813-1.75,5.934-11.849,5.934-11.849Z",
    transform: "translate(-2544.693 -966.251)",
    fill: "#fb8a77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_449",
    "data-name": "Path 449",
    d: "M2842.159,2409.231a4.393,4.393,0,0,0-2.252-.1,2.488,2.488,0,0,0-1.183.631c-.917.816-3.657,1.087-4.245,1.731-.671.735.64,1.145.64,1.145l6.974-.321c1.119.125.98-.456.98-.456S2843.593,2409.753,2842.159,2409.231Z",
    transform: "translate(-2806.635 -2292.724)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M2916.3,2365.752l.167,3.635a1.934,1.934,0,0,0,2.228-.1l-.167-3.635Z",
    transform: "translate(-2883.405 -2252.115)",
    fill: "#fb8a77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_451",
    "data-name": "Path 451",
    d: "M2858.69,1312.084s4.455,3.989,2.847,11.2-9.229,24.475-9.229,24.475l-1.6,29.948-3.832.053-4.081-33.55s3.9-35.311,6.413-35.713S2858.69,1312.084,2858.69,1312.084Z",
    transform: "translate(-2814.603 -1262.506)",
    fill: "#202234"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_452",
    "data-name": "Path 452",
    d: "M3475.742,2288.993a4.322,4.322,0,0,0-1.925,1.1,2.456,2.456,0,0,0-.653,1.146c-.334,1.16-2.471,2.823-2.622,3.667-.172.964,1.133.617,1.133.617l5.632-3.925c1-.483.576-.894.576-.894S3477.208,2288.675,3475.742,2288.993Z",
    transform: "translate(-3402.204 -2180.326)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_453",
    "data-name": "Path 453",
    d: "M3494.37,2255.354l2.046,2.935a1.9,1.9,0,0,0,1.8-1.254l-2.046-2.935Z",
    transform: "translate(-3424.524 -2147.695)",
    fill: "#fb8a77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_454",
    "data-name": "Path 454",
    d: "M2953.383,1313.786s.821-.733,3.992,5.934c1.79,3.764,1.909,11.952,1.909,11.952l4.316,13.981,13.319,29.58-2.306,1.633-20.673-27.745s-17.724-33.092-15.733-34.671S2953.383,1313.786,2953.383,1313.786Z",
    transform: "translate(-2903.765 -1267.24)",
    fill: "#232b57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_455",
    "data-name": "Path 455",
    d: "M2780.787,856.818c-4.79.692-10.916,5.337-11.777,11.306l5.877,1.562S2784.168,856.33,2780.787,856.818Z",
    transform: "translate(-2745.529 -839.717)",
    fill: "#e24444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_456",
    "data-name": "Path 456",
    d: "M2821.542,923.912l-1.162-.309,3.99-8.463S2823.122,922.885,2821.542,923.912Z",
    transform: "translate(-2793.616 -894.323)",
    fill: "#231f20",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_457",
    "data-name": "Path 457",
    d: "M2841.717,862.532s1.685-12.28-.3-14.467-5.83-2.6-4.253-6.929,3.954-9.737,6.75-11.576c.98-.633,4.563-.956,4.563-.956s8.685-2.556,9.4.633c.3,1.314.311,5.83.431,11.014.083,3.679.2,7.7.489,11.169.311,3.584.788,6.547,1.6,7.9C2862.456,862.735,2841.717,862.532,2841.717,862.532Z",
    transform: "translate(-2808.982 -812.412)",
    fill: "#e24444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_458",
    "data-name": "Path 458",
    d: "M3200.7,951.1l6.4,7.508-4.337,14.705,2.186.17s8.076-13.124,7.472-16.825c-.534-3.269-8.656-10.035-8.656-10.035Z",
    transform: "translate(-3149.625 -923.791)",
    fill: "#fb8a77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M3214.413,1359.614s-.173-1.118.036-1.367a1.772,1.772,0,0,1,1.457-.675A13.22,13.22,0,0,0,3214.413,1359.614Z",
    transform: "translate(-3162.399 -1308.458)",
    fill: "#fb8a77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M3216.943,1358.134c-.147.017-.294.06-.443.066a1.759,1.759,0,0,1,1.422-.637,5.876,5.876,0,0,0-.531.618A1.155,1.155,0,0,0,3216.943,1358.134Z",
    transform: "translate(-3164.416 -1308.451)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M3215.893,1300.151a4.743,4.743,0,0,1-.291.6h0s0,0,0,0-.028.06-.062.133h0c-.028.058-.064.128-.1.2,0,0-.406.857-.691.844a.334.334,0,0,1-.336-.223.408.408,0,0,1-.443.073.36.36,0,0,1-.233-.317.4.4,0,0,1-.456.048.518.518,0,0,1-.291-.415s-.288.258-.524-.156.173-.979.187-1.005c.058-.112.119-.218.182-.318a.472.472,0,0,1,.052-.081c1.6-1.655,2.647-5.321,3.051-5.387,0,0,1.853.381,1.847.85-.159.406-1.891,3.8-1.891,3.8A1.625,1.625,0,0,1,3215.893,1300.151Z",
    transform: "translate(-3160.565 -1249.106)",
    fill: "#fb8a77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M3215.618,1385.605v0l-.062.133h0c-.028.058-.064.128-.1.2,0,0-.406.857-.691.844a.333.333,0,0,1-.335-.223.408.408,0,0,1-.443.073.36.36,0,0,1-.233-.317.4.4,0,0,1-.457.048.518.518,0,0,1-.291-.415s-.288.258-.524-.156a.653.653,0,0,1-.052-.472.812.812,0,0,0,.372.388.366.366,0,0,0,.133.033c.052,0,.1-.01.156-.011.113,0,.184.084.259.156a.709.709,0,0,0,.335.207,1.38,1.38,0,0,0,.307.013.52.52,0,0,1,.3.075.8.8,0,0,0,.271.14.53.53,0,0,0,.478-.162,1.937,1.937,0,0,0,.23-.285c.093-.129.183-.261.273-.392a6.754,6.754,0,0,0,.436-.687,2.046,2.046,0,0,1-.071.207A4.748,4.748,0,0,1,3215.618,1385.605Z",
    transform: "translate(-3160.581 -1333.962)",
    fill: "#fff",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M3069.431,1036.19a17.73,17.73,0,0,0-1.636-3.034c-1.84-2.664-5.985-1.864-5.985-1.864,5.579-1.374,5.842-4.349,5.842-4.349a9.487,9.487,0,0,1,1.291-1.923C3069.025,1028.7,3069.145,1032.726,3069.431,1036.19Z",
    transform: "translate(-3019.614 -997.179)",
    fill: "#231f20",
    opacity: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M3145.26,831.94s6.82,3.393,9.42,9.042c0,0-3.064,3.36-5.389,4.147l-2.735-2.012Z",
    transform: "translate(-3097.729 -816.441)",
    fill: "#e24444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M2937.985,832.174l.809-.234s1.7,3.925-2.87,4.463-5.469-.942-5.469-.942a1.606,1.606,0,0,1,.861-1.8A51.649,51.649,0,0,1,2937.985,832.174Z",
    transform: "translate(-2896.622 -816.441)",
    fill: "#f56f58"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M2861.834,589.5c-.881.24-4.184.239-5.462,2.143-1.387,2,.291,5.514-1.8,5.9-2.262.043-1.285,2.86.627,4.095.928.618,3.07,1.032,4.033,1.567a10.354,10.354,0,0,0,6.579,1.177c2.176-.3,3.644-1.5,2.783-2.336-1.772-2.07.891-2.818-.88-5.022-1.427-1.945-.734-2.5-1.145-3.4C2865.3,590.666,2864.077,589.246,2861.834,589.5Z",
    transform: "translate(-2824.404 -589.468)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M2973.393,756.14l.614,6.09s-1.893,2.814-3.787.717l.051-4.094Z",
    transform: "translate(-2933.878 -745.486)",
    fill: "#f18a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M2971.833,771.318a1.985,1.985,0,0,1,.067-2.362c.255-.249.587-.405.833-.665a1.561,1.561,0,0,0,.317-1.237,12.187,12.187,0,0,1-.319-2.054l-2.469,2.145-.051,4.094a1.853,1.853,0,0,0,2.1.669A2.568,2.568,0,0,1,2971.833,771.318Z",
    transform: "translate(-2933.869 -753.78)",
    fill: "#33133f",
    opacity: 0.15
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M2893.518,642.211s-.341,9.791,3.548,10.1,5.6-3.787,5.6-3.787.716.444.887-.273,1.023-1.978.17-2.457-1.125.307-1.125.307l.477-2.217S2893.621,639,2893.518,642.211Z",
    transform: "translate(-2862.072 -637.817)",
    fill: "#f18a66"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M2916.9,719.783s.512-.277.717.123-.245,1.925-.849,1.74a1.243,1.243,0,0,0,.686-1.269C2917.365,719.445,2917.038,720.08,2916.9,719.783Zm-2.358,2.363c.045.272-.25.548-.661.617s-.782-.095-.827-.366.25-.548.662-.618S2914.5,721.873,2914.546,722.145Zm-4.656.026c.046.272-.25.548-.662.617s-.782-.095-.827-.367.25-.548.661-.617S2909.844,721.9,2909.89,722.171Z",
    transform: "translate(-2876.006 -711.365)",
    fill: "#33133f",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M2937.68,781.049a3.566,3.566,0,0,0,2.78-.089C2940.792,781.57,2939.052,783.158,2937.68,781.049Z",
    transform: "translate(-2903.418 -768.72)",
    fill: "#fcfaf7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M2960.581,801.532a.961.961,0,0,1-.208-.02.057.057,0,1,1,.026-.112,1.175,1.175,0,0,0,.966-.283.058.058,0,0,1,.075.087A1.3,1.3,0,0,1,2960.581,801.532Z",
    transform: "translate(-2924.618 -787.576)",
    fill: "#33133f",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M2883.8,623.119a5.647,5.647,0,0,0,0-.679c-4.043.358-2.1,4.554-2.1,4.554a4.139,4.139,0,0,0,2.035-3.27c1.086,1.487,4.486,3.267,8.287,3.344l.477-.842Z",
    transform: "translate(-2850.588 -620.332)",
    fill: "#231f20"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M2915.4,629.161a4.829,4.829,0,0,0,1.852,2.824,7.162,7.162,0,0,0,4.016,1.584,7.392,7.392,0,0,0,2.883-.4c.174-.059.1-.337-.076-.277a6.977,6.977,0,0,1-4.658,0,6.5,6.5,0,0,1-3.07-2.27,3.643,3.643,0,0,1-.668-1.533C2915.651,628.9,2915.375,628.98,2915.4,629.161Z",
    transform: "translate(-2882.563 -626.455)",
    fill: "#33133f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_482",
    "data-name": "Path 482",
    d: "M2407.242,1120.318a10.69,10.69,0,0,0,1.745-.116,3.958,3.958,0,0,0,.724-.231,4.629,4.629,0,0,0,.508-.255,4.148,4.148,0,0,0,.621-.429l5.51.224a8.22,8.22,0,0,0,0-2.744s-5.081.251-5.81-.357a.094.094,0,0,1-.021-.017c-.008-.012-.015-.024-.022-.036a1.728,1.728,0,0,0-.75-.506,4.253,4.253,0,0,0-.81-.24c-.667-.125-1.415-1.827-1.785-1.631s-.2,1.3.242,1.65.128.741-.408.741h-.169c-1.073,0-4.39.017-4.474.554-.055.35,1.322.482,2.39.532-1.309-.013-3.186.036-3.052.425.1.3,2,.482,3.063.574-.733,0-2.183.064-2.188.315-.011.543,1.492.617,2.506.607-.6.048-1.289.167-1.331.457C2403.681,1120.186,2405.65,1120.333,2407.242,1120.318Z",
    transform: "translate(-2401.675 -1080.438)",
    fill: "#fb8a77"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_483",
    "data-name": "Path 483",
    d: "M2453.657,1160.843s0,0,0,0l-1.652-.113,1.656.021h0s.064-.345.118-.512a5.446,5.446,0,0,0-.065.749c0,.093,0,.186,0,.279C2453.71,1161.268,2453.651,1160.891,2453.657,1160.843Zm0,1.045h0l-1.652-.113,1.645.021a1.032,1.032,0,0,1,.067-.412c0,.118.007.237.018.354a2.856,2.856,0,0,0,.066.426A.6.6,0,0,1,2453.655,1161.888Zm.209.82-1.656-.011,1.642-.081a1.026,1.026,0,0,1-.03-.339h0c.016.063.032.127.049.19.067.24.145.477.229.714C2454.015,1163.027,2453.871,1162.708,2453.864,1162.708Z",
    transform: "translate(-2448.783 -1123.756)",
    fill: "#231f20",
    opacity: 0.25
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82",
    transform: "translate(-397.524 4420.435)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_309",
    "data-name": "Path 309",
    d: "M141.591,97.99l1.844-.6s.765,5.006,6.9,8.817c11.941,5.233,12.228,4.029,13.074,1.556a.973.973,0,0,0-.458-1.162l-9.82-5.4S140.648,97.457,141.591,97.99Zm.417,52.144-.788-5.687s8.7-6.007,12.563-3.373l-1.172,42.352c-2.87,4.742-6.516,2.342-6.516,2.342l-1.948-25.693-17.113,11.17-2.135,1.315c-5.522.481-5.632-3.389-5.632-3.389Z",
    transform: "translate(-115.503 -58.853)",
    fill: "#f9977a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_310",
    "data-name": "Path 310",
    d: "M176.739,219.417a3.521,3.521,0,0,0,.693.148,2.04,2.04,0,0,0,.662-.041,3.211,3.211,0,0,0,.642-.215c.209-.1.424-.2.638-.33a1.89,1.89,0,0,1-1.213.863,1.543,1.543,0,0,1-.778-.029A1.439,1.439,0,0,1,176.739,219.417Zm10.254-7.383c.067,1.76.1,3.521.124,5.281.02.88.016,1.76.023,2.641a7.474,7.474,0,0,1-.435,2.645,7.387,7.387,0,0,1-1.373,2.3,20.756,20.756,0,0,1-1.873,1.882,10.337,10.337,0,0,1-4.581,2.57,8.246,8.246,0,0,0,2.366-1.121,14.774,14.774,0,0,0,2.048-1.634,26.077,26.077,0,0,0,1.818-1.891,7.319,7.319,0,0,0,1.736-4.755c.007-.88,0-1.76.023-2.641C186.9,215.556,186.927,213.8,186.994,212.035Z",
    transform: "translate(-150.234 -128.137)",
    fill: "#dd765e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_311",
    "data-name": "Path 311",
    d: "M172.211,144.9l2.224,23.151h-2.224V170.1l-14.63,1.756-.761-12.114-3.636-7.134a8.306,8.306,0,0,1-.9-4.109l.263-6.469Z",
    transform: "translate(-135.452 -85.831)",
    fill: "#ffba55"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_312",
    "data-name": "Path 312",
    d: "M116.318,272.872s-5.579-.245-6.52,2.86a1.085,1.085,0,0,0,.171.956l10.379,14.036a.569.569,0,0,0,.844.077,3.915,3.915,0,0,0,1.341-3.742c-.571-2.59-3.238-3.48-2.816-8.8C119.716,278.256,115.449,275.543,116.318,272.872ZM140.037,288.1s-3.521,4.4-1.569,6.991a1.085,1.085,0,0,0,.873.426l17.457-.095a.569.569,0,0,0,.56-.636,3.915,3.915,0,0,0-2.23-3.291c-2.428-1.068-4.151.856-8.2-2.626C146.928,288.874,141.68,290.382,140.037,288.1Z",
    transform: "translate(-109.754 -164.899)",
    fill: "#935b50"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_313",
    "data-name": "Path 313",
    d: "M171.944,3.8a7.8,7.8,0,0,1,3.642.312,6.24,6.24,0,0,1,3.538,2.81,9.511,9.511,0,0,1,.624,3.33,24.3,24.3,0,0,1,.523,3.188,11.188,11.188,0,0,1-.523,3.16c-.487,1.6-.173,2.511-.416,2.81-.979,1.206-3.95.26-3.995,1.834-.028.972,1.613,5.167,1.579,6.306-.078,2.653-4.508-.123-7.159-4.081-.12-.18-1.932-1.24-1.743-2.959.1-.918.881-5.227.806-5.783-.271-2.009-1.283-2.254-2.081-4.683a3.778,3.778,0,0,1,.624-3.642,7.717,7.717,0,0,1,4.579-2.6Z",
    transform: "translate(-144.06 -2.243)",
    fill: "#f9977a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_315",
    "data-name": "Path 315",
    d: "M180.941,22.519a2.3,2.3,0,0,0,.223,1.229,5.126,5.126,0,0,0,.64,1.086l.206.245a.5.5,0,0,1,.132.344.818.818,0,0,1-.347.591,1.476,1.476,0,0,1-1.27.161,1.585,1.585,0,0,0,1.186-.263.734.734,0,0,0,.274-.491c.013-.172-.181-.3-.315-.479a4.671,4.671,0,0,1-.627-1.141,2.02,2.02,0,0,1-.1-1.282Zm-6.685.172a1.55,1.55,0,0,0-.391.193,1.886,1.886,0,0,0-.326.273,6.122,6.122,0,0,0-.562.673c.016-.075.043-.145.065-.219l.1-.207a1.892,1.892,0,0,1,.278-.37A1.071,1.071,0,0,1,174.256,22.69Z",
    transform: "translate(-147.961 -13.608)",
    fill: "#dd765e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_316",
    "data-name": "Path 316",
    d: "M174.9,25.5a3.127,3.127,0,0,0-.01-.942,2.107,2.107,0,0,0-.113-.45c-.047-.15-.119-.29-.184-.443a1.372,1.372,0,0,1,.305.39,1.65,1.65,0,0,1,.162.475A1.49,1.49,0,0,1,174.9,25.5Z",
    transform: "translate(-148.937 -14.299)",
    fill: "#dd765e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_317",
    "data-name": "Path 317",
    d: "M170.761,13.088a19.206,19.206,0,0,1-.552-3.753,5.718,5.718,0,0,0,.119-2.22c-.223-.758.146-.857.622-1.672.446-.765,1.828-.146,2.173-.273.968-.358.932-.765,1.586-.806.671-.042,1.164-.219,1.6.214s1.253,1.617,1.453,1.413a3.824,3.824,0,0,0,.748-1.928,4.239,4.239,0,0,0-.475-1.981A3.5,3.5,0,0,0,176.05.063c-.709-.2-.845.139-2.38.23C172.079.387,172.03.032,171.2.268c-.923.262-.888.705-2.464,1.567a16.324,16.324,0,0,1-1.61.742c-1.979.838-2.238.7-2.694,1.144a3.756,3.756,0,0,0-.782,2.973c.109,1.109.542,1.443,1.484,3.22,1.492,2.814,1.192,4,1.739,4.391.268.194,1.683-.812,1.677-1.308-.009-.65-.477-.855-1.028-1.794a3.058,3.058,0,0,1-.62-2.453c.193-.516.408-.375.943-.325.726.067,1.083,1.079,1.374,1.821a3.973,3.973,0,0,1,.266,1.689C169.4,13.22,171.011,13.6,170.761,13.088Z",
    transform: "translate(-142.302 0)",
    fill: "#1e1d22"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_318",
    "data-name": "Path 318",
    d: "M189.913,36.288a2.152,2.152,0,0,0,3.044,0",
    transform: "translate(-158.195 -21.93)",
    fill: "#0a0709"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_319",
    "data-name": "Path 319",
    d: "M162.894,49.326s4.022,11.728-8.034-4.073l-3.738,3.1a9.336,9.336,0,0,0-3.154,5.177l-3.291,14.954h4.331l-1.053,15.06,20.307,2.965S167.753,57.661,162.894,49.326Z",
    transform: "translate(-130.859 -27.347)",
    fill: "#e24444"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_320",
    "data-name": "Path 320",
    d: "M153.671,103.294l-1.385,7.692,5.326,12.641,2.37,2.224a11.862,11.862,0,0,1-2.889,6.025,13.246,13.246,0,0,1-1.471-5.966l-9.65-11.12a7.185,7.185,0,0,1-1.666-5.86l.957-5.9S150.842,100.986,153.671,103.294Z",
    transform: "translate(-130.578 -61.758)",
    fill: "#f9977a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_321",
    "data-name": "Path 321",
    d: "M201.046,183.9c-.155-1.3-.274-2.6-.388-3.9s-.2-2.606-.3-3.909c-.075-1.3-.164-2.608-.226-3.914s-.118-2.611-.139-3.92c.155,1.3.274,2.6.388,3.9s.2,2.606.3,3.909c.074,1.3.164,2.608.226,3.914S201.025,182.593,201.046,183.9Z",
    transform: "translate(-164.287 -101.68)",
    fill: "#e6952a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_322",
    "data-name": "Path 322",
    d: "M186.9,128.21c-.4-.147-.785-.314-1.18-.472q-.57-.28-1.136-.576a13.929,13.929,0,0,1-2.095-1.461,9.567,9.567,0,0,1-1.7-1.911,5.384,5.384,0,0,1-.908-2.37,4.751,4.751,0,0,0,.456,1.168,7.7,7.7,0,0,0,.658,1.059,10.511,10.511,0,0,0,1.711,1.808,16.461,16.461,0,0,0,2.01,1.492l1.08.648C186.161,127.8,186.534,128,186.9,128.21Z",
    transform: "translate(-152.131 -73.377)",
    fill: "#b02336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_323",
    "data-name": "Path 323",
    d: "M153.456,52.8s5.784.819,4.413,8.9-2.1,11.7-2.1,11.7l-11.09-.351",
    transform: "translate(-130.859 -31.905)",
    fill: "#f73c4f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_324",
    "data-name": "Path 324",
    d: "M153.456,52.8a5.6,5.6,0,0,1,4.219,3.586,8.018,8.018,0,0,1,.39,1.4c.043.238.054.481.083.722a4.863,4.863,0,0,1,.046.724,15.613,15.613,0,0,1-.254,2.881l-1,5.661-1.036,5.653-.022.118-.122,0c-1.848-.058-3.7-.15-5.543-.224s-3.695-.181-5.542-.269c1.849.028,3.7.038,5.548.082s3.7.069,5.546.127l-.144.114,1-5.657,1.034-5.649a17.229,17.229,0,0,0,.285-2.83,4.682,4.682,0,0,0-.03-.708c-.023-.235-.029-.473-.066-.706a7.815,7.815,0,0,0-.351-1.369,5.761,5.761,0,0,0-1.534-2.346A5.476,5.476,0,0,0,153.456,52.8Z",
    transform: "translate(-130.859 -31.905)",
    fill: "#b02336"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_325",
    "data-name": "Path 325",
    d: "M176.647,154.65a12.1,12.1,0,0,1-.137,3.125,13.2,13.2,0,0,1-.9,3.013,10.4,10.4,0,0,1-1.691,2.653,9.484,9.484,0,0,1-2.423,1.977q.3-.251.606-.492l.3-.242c.1-.084.184-.182.277-.272l.553-.539c.169-.194.328-.4.493-.594a11.038,11.038,0,0,0,1.586-2.625,14.456,14.456,0,0,0,.951-2.927c.109-.5.2-1.013.257-1.527A13.765,13.765,0,0,0,176.647,154.65Z",
    transform: "translate(-147.066 -93.457)",
    fill: "#e6952a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_326",
    "data-name": "Path 326",
    d: "M186.245,43.838h0c-.708.116-1.268.327-1.287,1a5.689,5.689,0,0,0,.261,1.312c-1.57-.1-2.778-3.394-2.778-3.394C183.412,44.163,186.245,43.838,186.245,43.838Z",
    transform: "translate(-153.68 -25.84)",
    fill: "#dd765e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M215.9,123.29l5.872,3.762a15.8,15.8,0,0,0,4.479.692c1.091.045,4.37-.662,2.767-2.388a7.424,7.424,0,0,0-4.806-2.408c-.309-.055-2.344-.611-2.344-.611Z",
    transform: "translate(-173.897 -73.93)",
    fill: "#f9977a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M218.558,122.359s1.418-1.262,5.6-1.24,7.479.486,4.6,1.144l-2.2.465Z",
    transform: "translate(-175.506 -73.194)",
    fill: "#f9977a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M231.884,130.5l.514-.77a1.26,1.26,0,0,1,.627-.7l2.289-1.1a1.132,1.132,0,0,1,.8-.07l2.14.6a1.6,1.6,0,0,1,1.013,1.176l-.158.158s-2.8,1.751-4.468,1.248Z",
    transform: "translate(-183.559 -77.238)",
    fill: "#f9977a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M240.518,128.333a7.5,7.5,0,0,1,.149,1.377c0,.23,0,.461-.014.692a4.356,4.356,0,0,1-.091.69c-.058-.462-.083-.918-.1-1.377a10.148,10.148,0,0,1,.052-1.381Zm-1.737-.226a10.325,10.325,0,0,1,.21,1.635c.013.274.022.549.012.824a4.969,4.969,0,0,1-.077.824c-.058-.549-.106-1.091-.136-1.638A14.93,14.93,0,0,1,238.78,128.106Zm-1.461.646a5.482,5.482,0,0,1,.04,1.713,3.006,3.006,0,0,1-.123.564,9.85,9.85,0,0,1-.031-1.14A7.037,7.037,0,0,1,237.319,128.752Z",
    transform: "translate(-186.772 -77.417)",
    fill: "#dd765e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestTalk2);
export default __webpack_public_path__ + "static/media/guest_talk2.46825bab21b10dd38e338470b3ea2d6e.svg";
export { ForwardRef as ReactComponent };